export const DEFAULT_BREAKPOINT = "DESKTOP";
export const BREAKPOINTS = {
  MOBILE_SMALL: [0, 640],
  MOBILE_LARGE: [641, 800],
  TABLET: [801, 1024],
  DESKTOP_SMALL: [1025, 1300],
  DESKTOP_LARGE: [1301, 999999],
};
